module.exports = __webpack_public_path__ + "390562691f0379efc20c138c310d1b9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wing-video-cover.jpg
// module id = 2149
// module chunks = 1